// extracted by mini-css-extract-plugin
export default {"container":"ShiftTimeOffModal--container--dc175d","dates":"ShiftTimeOffModal--dates--a0d432","attentionContainer":"ShiftTimeOffModal--attentionContainer--112cbd"};